export const environment = {
  production: false,
  api_url: 'https://apidev.msla-id.com/experience-idv-monitor-v1/api',
  auth_url: 'https://apidev.msla-id.com/experience-core-security-api-v1/api',
  backend: true,
  hmr: false
};
